<template>
    <div class="preview-wrap">
        <div v-if="showSVG != '' && previewAvailable">
            <div class="svg-wrap preview-panel">
                <span v-html="showSVG"></span>
            </div>
        </div>
        <div v-if="showSVG == '' && !previewAvailable">
            <div class="svg-wrap preview-panel d-flex flex-column justify-content-center align-items-center pb-6">
                <h3 class="font-weight-bold">{{defaultText}}</h3>
                <button v-if="requestPrompt" class="btn btn-outline-dark" @click="request">Request</button>
            </div>
        </div>
        <div class="d-flex flex-column justify-content-center ml-5 mr-5 mt-2 mb-2" v-if="previewAvailable">
            <div class="d-flex align-items-center p-2">
                <select v-model="svgContent.typeValue" class="form-control form-control-sm rounded-0 preview-selector">
                    <option v-for="previewType in svgContent.types" :key="previewType.text" :value="previewType.text">
                        {{ previewType.text }}
                    </option>
                </select>
                <i class="fa fa-info-circle ul-html-tooltip" :data-tip="svgContent.typeTT" data-placement="top"></i>
            </div>
            <div class="d-flex align-items-center p-2">
                <select v-model="svgContent.nameValue" class="form-control form-control-sm rounded-0 preview-selector">
                    <option v-for="previewSymbol in svgContent.showNames" :key="previewSymbol.text" :value="previewSymbol.text">
                        {{ previewSymbol.text }}
                    </option>
                </select>
                <i class="fa fa-info-circle ul-html-tooltip" :data-tip="svgContent.nameTT" data-placement="top"></i>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "preview-svg",
        emits: ['openRequest', 'previewChanged'],
        data() {
            return {
                previewEmit: false
            };
        },
        props: {
            svgContent: {
                type: Object,
                default: () => {
                    return {
                        previews: [],
                        types: [],
                        typeTT: '',
                        names: [],
                        showNames: [],
                        nameTT: '',
                        typeValue: '',
                        nameValue: ''
                    }
                }
            },
            defaultText: {
                type: String,
                default: () => {
                    return ''
                }
            },
            requestPrompt: {
                type: Boolean,
                default: () => {
                    return false
                }
            }
        },
        computed: {
            showSVG: function () {
                if (this.svgContent.previews !== null) {
                    for (var i = 0; this.svgContent.previews && i < this.svgContent.previews.length; i++) {
                        if (this.svgContent.previews[i].name == this.svgContent.nameValue && this.svgContent.previews[i].type == this.svgContent.typeValue) {
                            return this.svgContent.previews[i].svgContent;
                        }
                    }
                }
                return "";
            },
            previewAvailable: function () {
                if (this.svgContent.previews !== null) {
                    if (this.svgContent.previews && this.svgContent.types && this.svgContent.names && this.svgContent.previews.length > 0 && this.svgContent.types.length > 0 && this.svgContent.names.length > 0) {
                        return true;
                    }
                }
                return false;
            }
        },
        methods: {
            request: function(){
                this.$emit('openRequest');
            }
        },
        watch: {
            'svgContent.typeValue': function (typeValue) {

                var showItems = [];

                if (this.svgContent.previews !== null) {
                    var names = [];

                    for (var nameI = 0; this.svgContent.previews && nameI < this.svgContent.previews.length; nameI++) {
                        if (this.svgContent.previews[nameI].type == typeValue) {
                            names.push(this.svgContent.previews[nameI].name);
                        }
                    }

                    var filterNames = names.filter((v, i, a) => a.indexOf(v) == i);

                    for (var showI = 0; this.svgContent.names && showI < this.svgContent.names.length; showI++) {
                        if (filterNames.indexOf(this.svgContent.names[showI].text) >= 0) {
                            showItems.push(this.svgContent.names[showI]);
                        }
                    }
                }

                this.svgContent.showNames = showItems;

                if (this.svgContent && this.svgContent.nameValue && this.svgContent.nameValue != "" && filterNames.indexOf(this.svgContent.nameValue) < 0)
                    this.svgContent.nameValue = this.svgContent.showNames[0].text;
            },
            'svgContent.names': function () {
                if (this.svgContent.previews !== null) {
                    var names = [];
                    var showItems = [];

                    for (var nameI = 0; this.svgContent.previews && nameI < this.svgContent.previews.length; nameI++) {
                        if (this.svgContent.previews[nameI].type == this.svgContent.typeValue) {
                            names.push(this.svgContent.previews[nameI].name);
                        }
                    }

                    var filterNames = names.filter((v, i, a) => a.indexOf(v) == i);

                    if (this.svgContent && this.svgContent.nameValue && this.svgContent.nameValue != "" && filterNames.indexOf(this.svgContent.nameValue) < 0)
                        this.svgContent.nameValue = this.svgContent.showNames[0].text;
                    else if (filterNames.indexOf(this.svgContent.nameValue) < 0)
                        this.svgContent.nameValue = '';


                    for (var showI = 0; this.svgContent.names && showI < this.svgContent.names.length; showI++) {
                        if (filterNames.indexOf(this.svgContent.names[showI].text) >= 0) {
                            showItems.push(this.svgContent.names[showI]);
                        }
                    }

                    this.svgContent.showNames = showItems;
                } else {
                    this.svgContent.nameValue = "";
                }

            },
            'showSVG': function () { // limits emits to one per cycle to prevent repeated issues due to how rendering occurs
                if (this.svgContent.previews !== null && this.svgContent.previews.length > 0) { // requires that there are previews
                    if(this.previewEmit == false){
                        this.previewEmit = true;
                        this.$nextTick(() => {
                            this.previewEmit = false;
                        });
                        this.$emit('previewChanged');
                    }
                }
            }

        }
    };
</script>

<style scoped>
</style>

